import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBv91hBK4N_1Jw_pfOglR36hOipQvMAynA",
  authDomain: "sugarcane-factory-d4196.firebaseapp.com",
  projectId: "sugarcane-factory-d4196",
  storageBucket: "sugarcane-factory-d4196.firebasestorage.app",
  messagingSenderId: "669264517506",
  appId: "1:669264517506:web:982cdca1be685c1463d79b",
  measurementId: "G-X1CTKC0FYM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };